import React from 'react';

/**
 * Component to display a "down arrow" svg icon
 * @param {*} props - Generic parameter to pass along any desired props to the component
 */
const SvgDownArrowIcon = (props) => (
  <svg
    viewBox="0 0 22 22"
    width="1em"
    height="1em"
    {...props}
    id="DownArrowIcon">
    <path
      d="M3.82 14.98h4.83V0h4.4v14.98h4.83L10.85 22l-7.03-7.02z"
      fill="currentColor"
    />
  </svg>
);

export default SvgDownArrowIcon;
